import './Notification.css'
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom'

import { fetchNoteCount, makeReadNote } from '../../../api/NotificationRequest';
import { setUnreadNoteCount } from '../../../actions/notificationActions';
import { List, Badge, Empty } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { MdOutlineNotifications } from 'react-icons/md';


const Notification = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authReducer.authData);
    const [allNote, setAllNote] = useState([]);
    const [noteCount, setNoteCount] = useState(0);
    const count_unread_note = useSelector((state) => state.notificationReducer.noteCount);
    
    const changeDate = (time) => {
        const date = new Date(time);
        return (date.toDateString());
    }

    const open_note = (id) => {
        navigate('/viewnote', { state: { noteId: id } });
    }

    const fetchnote = async () => {
        try {

            const unread_note_arr = (await fetchNoteCount(user._id)).data;
            dispatch(setUnreadNoteCount(unread_note_arr));

        } catch (error) {
            console.error('Error fetching announcement:', error);
        }
    };
    useEffect(() => {


        fetchnote();
    }, []);
    useEffect(() => {
        let items = [];
        if (count_unread_note) {
            count_unread_note?.forEach((note, index) => {
                
                items.push(
                    {
                        index: index,
                        title: note.title,
                        text: note.text,
                        time: note.updatedAt,
                        _id: note._id
                    }
                )
                // }
            });
            setAllNote(items); // Update state with fetched notes
        }
        // console.log(items)
        setNoteCount(items.length);
    }, [count_unread_note])
    
    const text_over_flag = (text) => {
        if (text && text.length > 100) {
            return true;
        } else {
            return false;
        }
    }

    const make_elipse_text = (text, index, time) => {
        return (
            text_over_flag(text) ?
                <>
                    <div class="text-container">
                        <p id={`text${index}`} class="collapsed" dangerouslySetInnerHTML={{ __html: text }}>
                        </p>
                        <div class="footer">
                            <span class="date-font">{changeDate(time)}</span>
                            <span   id={`toggleButton${index}`} onClick={() => { show_detail_btn(index) }}>
                                <button class="show-more" >Show More</button>
                            </span>
                        </div>
                    </div>
                </>
                :
                <>
                    <div>
                        {text}
                        <div class="footer">
                            <span class="date-font">{changeDate(time)}</span>
                        </div>
                    </div>
                </>
        );
    }

    const show_detail_btn = (index) => {
        const textElement = document.getElementById("text" + index);
        if (textElement.classList.contains("collapsed")) {
            textElement.classList.remove("collapsed");
            textElement.classList.add("expanded");
            // this.textContent = "Show Less";
            document.getElementById('toggleButton'+index).innerHTML='<button class="show-more" >Show Less</button>';
        } else {
            textElement.classList.remove("expanded");
            textElement.classList.add("collapsed");
            // this.textContent = "Show More";
            document.getElementById('toggleButton'+index).innerHTML='<button class="show-more" >Show More</button>';
        }
    }
    const sel_list = async (index, id) => {

        await makeReadNote(id, user._id);
        document.getElementById('btn' + index).style.display = 'none';
        fetchnote();
    }


    return (
        <>
            <div
                className="notification-icon dropdown dropbtn flex items-center"
            >
                <div className='flex items-center'>
                    {noteCount > 0 ? (
                      <Badge count={noteCount} size='small'  style={{ fontSize: '10px', minWidth: '14px', height: '14px', lineHeight: '14px', padding: '0 4px'}}>
                        <MdOutlineNotifications style={{width:'19px', height:'19px'}} />
                      </Badge>
                    ): (
                        <MdOutlineNotifications style={{width:'19px', height:'19px', marginRight: '-6px'}} />
                    )}
                    <Link to={`/viewnote`}>
                        <span className='FlexRow h-page-span notification-text'> Notifications</span>
                    </Link>
                </div>
                <div class="dropdown-content absolute top-[50px]">
                    <div className="alarm_head">
                        <>
                            {user && <Link className='linkcss' to={`/viewnote`}><span className='FlexRow h-page-span'> Open Notifications Panel</span></Link>}
                            {user && user.isAdmin && (<Link className='linkcss' to={`/createnote`}><span className='FlexRow h-page-span'> Create Note</span></Link>)}
                        </>
                    </div>
                    {
                        <List
                            itemLayout='horizontal'
                            dataSource={allNote}
                            locale={{ emptyText: <Empty description='You have no new notifications' /> }}
                            renderItem={(item, index) => (
                                // item.note_type == 1 &&
                                <List.Item
                                    id={`btn${index}`}
                                >
                                    <List.Item.Meta
                                        style={{ paddingRight: 15, paddingLeft: 0 }}
                                        // style={{ paddingLeft: 10 }}
                                        avatar={<span style={{ paddingRight: 10, paddingLeft: 15 }}><FileTextOutlined /></span>}
                                        title={<a onClick={() => open_note(item._id)}>{item.title}</a>}
                                        description={make_elipse_text(item.text, index, item.time)}
                                    />
                                </List.Item>
                            )}
                        />
                    }
                </div>
            </div>

            {/* {isModalOpen && <Alarm_modal onClose={toggleModal} />} */}
        </>
    )

}

export default Notification;